var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4887 7.1649C13.4887 11.468 9.08131 14.119 8.1654 14.6239C8.11466 14.6519 8.05766 14.6666 7.99971 14.6666C7.94176 14.6666 7.88476 14.6519 7.83402 14.6239C6.91743 14.119 2.51144 11.468 2.51144 7.1649C2.51144 3.73452 4.56967 1.33325 8.00005 1.33325C11.4304 1.33325 13.4887 3.73452 13.4887 7.1649Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25577 6.82194C5.25577 7.54978 5.5449 8.2478 6.05956 8.76246C6.57421 9.27711 7.27224 9.56625 8.00007 9.56625C8.72791 9.56625 9.42593 9.27711 9.94059 8.76246C10.4552 8.2478 10.7444 7.54978 10.7444 6.82194C10.7444 6.09411 10.4552 5.39608 9.94059 4.88142C9.42593 4.36677 8.72791 4.07764 8.00007 4.07764C7.27224 4.07764 6.57421 4.36677 6.05956 4.88142C5.5449 5.39608 5.25577 6.09411 5.25577 6.82194V6.82194Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.f22352c4007acfd0c511e2d2cb935a99.svg";
export { ForwardRef as ReactComponent };